import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";

export const requestDeleteAffinityRule = async (
  id: string
): Promise<{ ok: true }> => {
  return await instance.delete(`${ApiRoutesRecommendation.Affinity}/${id}`);
};
